"use strict";
const $ = (s, r) => (r||document).querySelector(s);
const $$ = (s, r) => Array.from((r||document).querySelectorAll(s));
const money = c => "R" + (c/100).toLocaleString("en-ZA", {minimumFractionDigits: (c%100?2:0), maximumFractionDigits: 2});
let toastTimer;
function toast(msg){ const t = $("#toast"); if(!t) return; t.innerHTML = msg; t.classList.add("show"); clearTimeout(toastTimer); toastTimer = setTimeout(()=>t.classList.remove("show"), 2600); }
function overlay(show){ $("#overlay") && $("#overlay").classList.toggle("show", show); }
function closeAll(){ ["#cartDrawer","#mmenu","#qv","#overlay"].forEach(s => $(s) && $(s).classList.remove("show")); $$(".hot-pop").forEach(p=>p.classList.remove("show")); }
document.addEventListener("keydown", e => { if(e.key === "Escape") closeAll(); });
document.addEventListener("click", e => { if(e.target.id === "overlay") closeAll(); });

/* ---------- cart ---------- */
async function getCart(){ return (await fetch("/cart.js")).json(); }
async function addToCart(id, qty){
  const r = await fetch("/cart/add.js", {method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({id: Number(id), quantity: qty||1})});
  if(!r.ok){ const e = await r.json().catch(()=>({})); toast(e.description || "Could not add to cart"); return false; }
  await renderCart(); openCart();
  $$(".cart-count").forEach(b => { b.classList.remove("pop"); void b.offsetWidth; b.classList.add("pop"); });
  return true;
}
async function changeLine(key, qty){
  await fetch("/cart/change.js", {method:"POST", headers:{"Content-Type":"application/json"}, body: JSON.stringify({id:key, quantity:qty})});
  renderCart();
}
function openCart(){ closeAll(); $("#cartDrawer").classList.add("show"); overlay(true); }
async function renderCart(){
  const cart = await getCart();
  const n = cart.item_count;
  $$(".cart-count").forEach(b => { b.style.display = n ? "grid" : "none"; b.textContent = n; });
  const FREE = (window.themeSettings && themeSettings.freeShip || 500) * 100;
  const fsb = $("#fsb");
  if(fsb){
    fsb.innerHTML = cart.total_price >= FREE
      ? "<b>Complimentary delivery unlocked</b><div class='fsb-bar'><div class='fsb-fill' style='width:100%'></div></div>"
      : "You're <b>" + money(FREE - cart.total_price) + "</b> away from complimentary SA delivery<div class='fsb-bar'><div class='fsb-fill' style='width:" + Math.min(100, cart.total_price/FREE*100) + "%'></div></div>";
  }
  const box = $("#cartItems");
  if(!box) return;
  if(!cart.items.length){
    box.innerHTML = "<div class='cart-empty'><div class='serif' style='font-size:23px;color:var(--ink)'>Your cart is empty</div><p>Satin is waiting.</p></div>";
    $("#cartFoot").innerHTML = "";
    return;
  }
  box.innerHTML = cart.items.map(it => `
    <div class="cart-line">
      <img src="${it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/, "_160x$1$2") : ""}" alt="${it.product_title}" loading="lazy">
      <div class="t"><b>${it.product_title}</b><span class="v">${it.variant_title && it.variant_title !== "Default Title" ? it.variant_title + " · " : ""}${money(it.price)}</span>
        <div class="row">
          <div class="mini-qty"><button aria-label="Decrease" onclick="changeLine('${it.key}',${it.quantity-1})">−</button><span>${it.quantity}</span><button aria-label="Increase" onclick="changeLine('${it.key}',${it.quantity+1})">+</button></div>
          <div><b>${money(it.final_line_price)}</b><button class="rm" onclick="changeLine('${it.key}',0)">Remove</button></div>
        </div>
      </div>
    </div>`).join("");
  $("#cartFoot").innerHTML = `
    <div class="subtotal"><span>Subtotal</span><span>${money(cart.total_price)}</span></div>
    <small>Taxes included. Delivery calculated at checkout.</small>
    <a class="btn btn-acc btn-block" href="/checkout">Checkout — ${money(cart.total_price)}</a>
    <a class="btn btn-outline btn-block" style="margin-top:8px" href="/cart">View cart</a>`;
}

/* ---------- product form (PDP + quick view) ---------- */
function initProductForm(root){
  const dataEl = $("[data-product-json]", root);
  if(!dataEl) return;
  const product = JSON.parse(dataEl.textContent);
  const state = product.options.map((o,i) => {
    const sel = $$("[data-opt-index='"+i+"']", root);
    const on = sel.find(x => x.classList.contains("on") || x.selected);
    return on ? (on.dataset.value || on.value) : (product.variants.find(v=>v.available)||product.variants[0])["option"+(i+1)];
  });
  function resolve(){
    const v = product.variants.find(v => state.every((s,i) => v["option"+(i+1)] === s)) || null;
    const priceEl = $("[data-price]", root), btn = $("[data-atc]", root), idEl = $("[data-vid]", root);
    if(v){
      idEl.value = v.id;
      priceEl.innerHTML = "<b>" + money(v.price) + "</b>" + (v.compare_at_price > v.price ? " <span class='was'>" + money(v.compare_at_price) + "</span>" : "");
      btn.disabled = !v.available;
      btn.textContent = v.available ? (btn.dataset.label || "Add to cart") + " — " + money(v.price) : "Sold out";
      const st = $("#stickyPrice"); if(st) st.textContent = money(v.price);
      if(v.featured_image){ const main = $("[data-main-img]", root); if(main){ main.src = v.featured_image.src; main.srcset = ""; } }
    } else { btn.disabled = true; btn.textContent = "Unavailable"; }
  }
  $$("[data-opt-index]", root).forEach(el => {
    const i = Number(el.dataset.optIndex);
    if(el.tagName === "SELECT"){ el.addEventListener("change", () => { state[i] = el.value; resolve(); }); }
    else el.addEventListener("click", () => { $$("[data-opt-index='"+i+"']", root).forEach(x=>x.classList.remove("on")); el.classList.add("on"); state[i] = el.dataset.value; const lbl = $("[data-opt-label='"+i+"']", root); if(lbl) lbl.textContent = el.dataset.value; resolve(); });
  });
  const form = $("form[data-product-form]", root);
  form && form.addEventListener("submit", async e => {
    e.preventDefault();
    const qtyEl = $("[data-qty]", root);
    await addToCart($("[data-vid]", root).value, qtyEl ? Math.max(1, parseInt(qtyEl.value)||1) : 1);
    toast("Added <b>" + product.title + "</b> to your cart");
  });
  resolve();
}

/* ---------- quick view ---------- */
async function openQV(handle){
  const p = await (await fetch("/products/" + handle + ".js")).json();
  const card = $("#qvCard");
  card.innerHTML = `
    <button class="x" onclick="closeAll()" aria-label="Close">✕</button>
    <div class="modal-img"><img data-main-img src="${p.featured_image}" alt="${p.title}"></div>
    <div class="modal-info">
      <h3>${p.title}</h3>
      <div class="pdp-price" data-price></div>
      <p style="font-size:13.5px;color:var(--ink-soft);margin-bottom:14px">${(p.description||"").replace(/<[^>]+>/g," ").slice(0,140)}…</p>
      <form data-product-form>
        ${p.options.map((o,i) => o.name.toLowerCase() === "color" || o.name.toLowerCase() === "colour"
          ? `<span class="opt-label">${o.name} — <span data-opt-label="${i}"></span></span><div class="swatches">${o.values.map(v => `<button type="button" class="sw" data-opt-index="${i}" data-value="${v}" title="${v}" aria-label="${v}" style="background:${window.swatchColor(v)}"></button>`).join("")}</div>`
          : `<span class="opt-label">${o.name}</span><select class="size-select" data-opt-index="${i}">${o.values.map(v=>`<option value="${v}">${v}</option>`).join("")}</select>`
        ).join("")}
        <input type="hidden" data-vid name="id">
        <button type="submit" class="btn btn-acc btn-block" data-atc style="margin-top:14px">Add to cart</button>
      </form>
      <a href="/products/${p.handle}" style="font-size:12px;color:var(--acc);text-decoration:underline;display:inline-block;margin-top:12px">View full details →</a>
      <script type="application/json" data-product-json>${JSON.stringify({title:p.title, options:p.options, variants:p.variants})}</script>
    </div>`;
  p.options.forEach((o,i) => { const first = $("[data-opt-index='"+i+"']", card); if(first && first.classList.contains("sw")) first.classList.add("on"); });
  initProductForm(card);
  closeAll(); $("#qv").classList.add("show"); overlay(true);
}
window.swatchColor = v => ({ "black":"#26211E","white":"#F0EBE3","pink":"#E8B7C2","light pink":"#E8B7C2","red":"#8E2F33","burgundy":"#7A2E35","royal blue":"#2E4C8F","baby blue":"#A9C6E8","light blue":"#A9C6E8","blue":"#2E4C8F","navy":"#22304E","emerald green":"#2F6B4F","green":"#2F6B4F","dark green":"#2F5040","silver":"#B9B9B9","silver grey":"#B9B9B9","grey":"#9A9A9A","gray":"#9A9A9A","champagne":"#D9C6A8","champange":"#D9C6A8","deep purple":"#5A3E6B","purple":"#6B4E79","light purple":"#9B7FA8","cyan":"#7FBFC9","khaki":"#B4A67E","brown":"#6E4A38" }[String(v).toLowerCase()] || "#C9A86A");

/* ---------- card swatches (image swap) ---------- */
function initCards(root){
  $$("[data-card]", root).forEach(cardEl => {
    $$(".sw[data-img]", cardEl).forEach(sw => sw.addEventListener("click", e => {
      e.preventDefault();
      $$(".sw", cardEl).forEach(x=>x.classList.remove("on")); sw.classList.add("on");
      const img = $("img[data-card-img]", cardEl);
      if(img && sw.dataset.img){ img.src = sw.dataset.img; img.srcset = ""; }
    }));
  });
}

/* ---------- hotspots ---------- */
function initHotspots(){
  $$(".hot").forEach(h => h.addEventListener("click", e => {
    e.stopPropagation();
    const stl = h.closest(".stl"), pop = $(".hot-pop", stl);
    pop.innerHTML = `<div class="row"><img src="${h.dataset.img}" alt=""><div><div class="t">${h.dataset.title}</div><div class="p">${h.dataset.price}</div></div></div>
      <button class="btn btn-acc" onclick="(async()=>{this.disabled=true;await addToCart('${h.dataset.vid}',1);this.closest('.hot-pop').classList.remove('show')})()">Add to cart</button>
      <a href="${h.dataset.url}" style="display:block;text-align:center;font-size:11px;margin-top:8px;color:var(--acc);text-decoration:underline">View product</a>`;
    const stlRect = stl.getBoundingClientRect();
    const maxLeftPct = Math.max(0, (stlRect.width - 252) / stlRect.width * 100);
    pop.style.left = Math.min(parseFloat(h.style.left), maxLeftPct) + "%";
    pop.style.top = Math.min(parseFloat(h.style.top) + 8, 72) + "%";
    pop.classList.add("show");
  }));
  document.addEventListener("click", e => { if(!e.target.closest(".hot") && !e.target.closest(".hot-pop")) $$(".hot-pop").forEach(p=>p.classList.remove("show")); });
}

/* ---------- accessibility: ensure every swatch has a spoken label ---------- */
function ensureSwatchLabels(root){
  $$(".sw", root||document).forEach(sw => {
    if(!sw.getAttribute("aria-label")){
      const v = sw.dataset.value || sw.title || sw.dataset.swatch || "";
      if(v) sw.setAttribute("aria-label", v);
    }
  });
}

/* ---------- Édition Un: recently viewed + section progress dots ---------- */
function currentProductHandle(){
  const m = location.pathname.match(/\/products\/([^/?#]+)/);
  return m ? m[1] : null;
}
function trackViewed(){
  const h = currentProductHandle();
  if(!h) return;
  let list = JSON.parse(localStorage.getItem("silRecent") || "[]").filter(x => x !== h);
  list.unshift(h);
  localStorage.setItem("silRecent", JSON.stringify(list.slice(0,6)));
}
async function renderRecent(){
  const box = $("#recentRail");
  if(!box) return;
  const cur = currentProductHandle();
  const list = JSON.parse(localStorage.getItem("silRecent") || "[]").filter(h => h !== cur).slice(0,5);
  const wrap = box.closest(".recently");
  if(!list.length){ if(wrap) wrap.style.display = "none"; return; }
  const products = await Promise.all(list.map(h => fetch("/products/"+h+".js").then(r=>r.ok?r.json():null).catch(()=>null)));
  const ok = products.filter(Boolean);
  if(!ok.length){ if(wrap) wrap.style.display = "none"; return; }
  box.innerHTML = ok.map(p => `<a class="card" href="${p.url}"><div class="card-img"><img src="${p.featured_image}" alt="${p.title}" loading="lazy"></div><h3>${p.title}</h3><div class="price"><span class="now">${money(p.price)}</span></div></a>`).join("");
}
function initProgressDots(){
  const dots = $("#progressDots");
  const sections = $$("main .section");
  if(!dots || !sections.length) return;
  dots.innerHTML = sections.map((_,i) => `<button aria-label="Go to section ${i+1}" data-i="${i}"></button>`).join("");
  $$("#progressDots button").forEach(b => b.addEventListener("click", () => sections[Number(b.dataset.i)].scrollIntoView({behavior:"smooth"})));
  const io = new IntersectionObserver(entries => {
    entries.forEach(e => { if(e.isIntersecting){ const i = sections.indexOf(e.target); $$("#progressDots button").forEach((b,bi)=>b.classList.toggle("on", bi===i)); } });
  }, {threshold:.5});
  sections.forEach(s => io.observe(s));
}

/* ---------- Édition Un: cinema motion (Ken Burns) for real photography — progressive enhancement, never hides content ---------- */
function initCinemaMotion(){
  try{
    $$(".hero .bg img, .bento .b-item img, .gal-main img").forEach(img => {
      const mark = () => img.classList.add("motion-kb");
      if(img.complete && img.naturalWidth) mark();
      else img.addEventListener("load", mark, {once:true});
    });
  }catch(err){ /* motion is decorative only — static images remain fully visible either way */ }
  const cards = $$(".card-img img");
  if(!cards.length) return;
  const settle = el => el.classList.add("kb-in");
  if(!("IntersectionObserver" in window)){ cards.forEach(settle); return; }
  try{
    const io = new IntersectionObserver(entries => {
      entries.forEach(e => { if(e.isIntersecting){ settle(e.target); io.unobserve(e.target); } });
    }, {threshold:.1, rootMargin:"0px 0px -30px 0px"});
    cards.forEach(c => io.observe(c));
  }catch(err){ cards.forEach(settle); }
  setTimeout(() => cards.forEach(settle), 3000);
}
function injectEditionUnChrome(){
  if(!$("#progressDots")) document.body.insertAdjacentHTML("beforeend", '<nav class="progress-dots" id="progressDots" aria-label="Page sections"></nav>');
  const firstSection = $("main .section");
  if(firstSection && !$("#recentRail")){
    firstSection.insertAdjacentHTML("afterend", '<section class="recently"><div class="wrap"><span class="kicker">Welcome Back</span><h2 class="serif">Recently viewed</h2><div class="grid" id="recentRail"></div></div></section>');
  }
}

/* ---------- misc ---------- */
function accToggle(btn){ const open = btn.parentElement.classList.toggle("open"); btn.setAttribute("aria-expanded", open); const s = $("span", btn); if(s) s.textContent = open ? "−" : "+"; }
function qtyStep(root, d){ const i = $("[data-qty]", root.closest ? root.closest(".pdp-info") || document : document); if(i) i.value = Math.max(1, (parseInt(i.value)||1) + d); }

document.addEventListener("DOMContentLoaded", () => {
  // FAQ toggles bound FIRST and defensively, so an error anywhere else on
  // the page can never prevent these from working.
  try {
    $$(".faq-q").forEach(q => q.addEventListener("click", () => {
      const open = q.parentElement.classList.toggle("open");
      q.setAttribute("aria-expanded", open);
    }));
  } catch (err) { console.error("FAQ init failed:", err); }

  try { renderCart(); } catch (err) { console.error("renderCart failed:", err); }
  try { initCards(document); } catch (err) { console.error("initCards failed:", err); }
  try { initHotspots(); } catch (err) { console.error("initHotspots failed:", err); }
  try { ensureSwatchLabels(document); } catch (err) { console.error("ensureSwatchLabels failed:", err); }

  try {
    $$("[data-pdp]").forEach(el => {
      try { initProductForm(el); }
      catch (err) { console.error("initProductForm failed for one element:", err); }
    });
  } catch (err) { console.error("PDP init failed:", err); }

  try { injectEditionUnChrome(); } catch (err) { console.error("injectEditionUnChrome failed:", err); }
  try { trackViewed(); } catch (err) { console.error("trackViewed failed:", err); }
  try { renderRecent().then(initCinemaMotion); } catch (err) { console.error("renderRecent failed:", err); }
  try { initProgressDots(); } catch (err) { console.error("initProgressDots failed:", err); }
  try { initCinemaMotion(); } catch (err) { console.error("initCinemaMotion failed:", err); }
});

document.addEventListener("DOMContentLoaded", () => { $$("[data-swatch]").forEach(sw => { sw.style.background = swatchColor(sw.dataset.swatch); }); });